<mat-tab-group
  dynamicHeight
  (selectedTabChange)="onTabChanged($event)"
  [(selectedIndex)]="selectedIndex"
>
  <mat-tab [disabled]="isImporting" label="General Notes"> </mat-tab>
  <mat-tab [disabled]="isImporting" label="Design/Mock-up Notes"> </mat-tab>
  <mat-tab
    [disabled]="isImporting"
    *ngFor="let description of cardNotes.additional; let i = index"
    [label]="cardNotes.additional[i].title"
  >
    <ng-template mat-tab-label>
      <input
        *ngIf="selectedIndex - 2 == i"
        type="text"
        class="form-control"
        [(ngModel)]="cardNotes.additional[i].title"
        (keydown)="handleAddlInput($event)"
        debounceKeyUp
        [debounceTime]="debounceTime"
        (onEvent)="handleUpdateCommentTab(i, cardNotes.additional[i])"
      />
      <ng-container *ngIf="selectedIndex - 2 != i">{{
        cardNotes.additional[i].title
      }}</ng-container>
      <ng-container *ngIf="isUpdating && selectedIndex - 2 == i"
        ><i class="fas fa-spinner fa-spin"></i
      ></ng-container>
      <button
        *ngIf="selectedIndex - 2 == i"
        mat-icon-button
        (click)="deleteCommentTab(i)"
        class="text-danger"
      >
        <mat-icon>close</mat-icon>
      </button>
    </ng-template>
  </mat-tab>
  <mat-tab disabled>
    <ng-template mat-tab-label>
      <button mat-icon-button (click)="createCommentTab()"
        ><mat-icon>add_circle</mat-icon> Add New</button
      >
    </ng-template>
  </mat-tab>
</mat-tab-group>

<div class="notes">
  <div class="row mb-3">
    <div class="col-md-12">
      <ng-container
        *ngTemplateOutlet="
          noteForm;
          context: {
            note: null,
            commentHandler: commentHandler,
          }
        "
      >
      </ng-container>
    </div>
  </div>
  <div
    class="bg-gray note-row p-2"
    *ngFor="
      let u of selectedIndex == 0
        ? cardNotes.general
        : selectedIndex == 1
          ? cardNotes.design
          : cardNotes.additional[selectedIndex - 2].comments;
      let i = index
    "
  >
    <div class="d-flex flex-row user-info">
      <p
        [attr.data-lettersmall]="
          u?.user?.firstname?.charAt(0).toUpperCase() +
          u?.user?.lastname?.charAt(0).toUpperCase()
        "
      ></p>
      <div class="flex-column justify-content-start ml-2">
        <span class="font-weight-bold name text-capitalize"
          >{{ u?.user?.firstname }} {{ u?.user?.lastname }}</span
        >
        <small class="date ml-2">{{ u.created_at | date: 'medium' }}</small>
      </div>
    </div>
    <div class="note-body">
      <div class="" *ngIf="!u.editable">
        <div class="actions pull-right">
          <a
            [class.disabled]="isImporting"
            (click)="u.editable = true"
            class="text-info mr-2"
            href="javascript:void(0);"
          >
            <i class="fas fa-edit"></i> Edit</a
          >
          <a
            (click)="deleteComment(u, i)"
            class="text-danger"
            [class.disabled]="isImporting"
            href="javascript:void(0);"
          >
            <i class="fas fa-trash"></i> Delete</a
          >
        </div>

        <p class="comment-text m-0 p-0">{{ u.body }}</p>
        <div
          class=""
          *ngIf="u.assigned_attachments && u.assigned_attachments.length > 0"
        >
          <span
            class="badge badge--outline-primary m-1"
            *ngFor="let atta of u.assigned_attachments; let idx = index"
          >
            <a (click)="viewAttachment(atta)" class="" href="javascript:void(0);">
              <i class="fa fa-paperclip mr-1" aria-hidden="true"></i
              >{{ atta.fileurl }}
            </a>
            <a
              href="javascript:;"
              class="ml-1 text-danger"
              title="Remove"
              (click)="deleteAttachment(u, atta.id, idx)"
            >
              <i class="fas fa-times"></i>
            </a>
          </span>
        </div>
      </div>
      <div class="" *ngIf="u.editable">
        <ng-container
          *ngTemplateOutlet="
            noteForm;
            context: {
              note: u,
              commentHandler: commentHandler,
            }
          "
        >
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template let-note="note" let-commentHandler="commentHandler" #noteForm>
  <textarea
    *ngIf="!note"
    [(ngModel)]="commentHandler.body"
    class="form-control textarea"
    atMention
    [atMentionItems]="staff"
  ></textarea>
  <textarea
    *ngIf="note"
    [(ngModel)]="note.body"
    class="form-control textarea"
    atMention
    [atMentionItems]="staff"
  ></textarea>
  <span
    class="badge badge--outline-primary m-1"
    *ngFor="
      let file of note ? note.filestoupload : commentHandler.filestoupload;
      let i = index
    "
  >
    {{ file.file.name }}
    <a
      href="javascript:;"
      class="ml-1 text-danger"
      title="Remove"
      (click)="
        note
          ? note.filestoupload.splice(i, 1)
          : commentHandler.filestoupload.splice(i, 1)
      "
    >
      <i class="fas fa-times"></i>
    </a>
  </span>

  <div class="mt-2">
    <button
      [disabled]="isImporting"
      class="btn btn-primary btn-sm"
      (click)="saveNote(note)"
      type="button"
    >
      <span *ngIf="!isImporting">Save</span>
      <mat-spinner [diameter]="20" *ngIf="isImporting"></mat-spinner>
    </button>
    <button
      [disabled]="isImporting"
      class="btn btn-outline-primary btn-sm ml-1"
      (click)="clearNoteForm(note)"
      type="button"
    >
      <span *ngIf="!note">Clear</span>
      <span *ngIf="note">Cancel</span>
    </button>
    <input
      type="file"
      hidden
      #uploader
      class="form-control"
      id="files"
      multiple
      (change)="handleFileInput($event, note)"
    />
    <button
      [disabled]="isImporting"
      (click)="uploader.click()"
      class="btn btn-outline-primary btn-sm float-right"
      type="button"
    >
      <i class="fa fa-paperclip" aria-hidden="true"></i>
    </button>
  </div>
</ng-template>

<!--div>
	<small class="label">Note/s</small>
	<div class="d-flex flex-column comment-section">
		<div class="row mb-5">
			<div class="col-md-12">
				<textarea [(ngModel)]="comment_handler.body" class="form-control textarea"></textarea>

				<span class="badge badge-primary m-1" *ngFor="let file of comment_handler.filestoupload; let i = index">
					{{ file.file.name }}
					<a href="javascript:;" class="text-danger" title="Remove" (click)="comment_handler.filestoupload.splice(i, 1)">
						<i class="fas fa-times"></i>
					</a>
				</span>

				<div class="mt-2">
					<button [disabled]="isImporting" class="btn btn-primary btn-sm" (click)="saveComment()" type="button">
						<span *ngIf="!isImporting">Save</span>
						<mat-spinner [diameter]="20" *ngIf="isImporting"></mat-spinner>
					</button>
					<button [disabled]="isImporting" class="btn btn-outline-primary btn-sm ml-1" (click)="clearComment()" type="button">Clear</button>
					<input type="file" hidden #uploader class="form-control" id="files" multiple (change)="handleFileInput($event)" />
					<button [disabled]="isImporting" (click)="uploader.click()" class="btn btn-outline-primary btn-sm float-right" type="button">
						<i class="fa fa-paperclip" aria-hidden="true"></i>
					</button>
				</div>
			</div>
		</div>
		<div class="bg-white p-2" *ngFor="let u of design.assigned_comments; let i = index">
			<div class="d-flex flex-row user-info">
				<p [attr.data-lettersmall]="u?.user?.firstname?.charAt(0).toUpperCase() + u?.user?.lastname?.charAt(0).toUpperCase()"></p>
				<div class="d-flex flex-column justify-content-start ml-2">
					<span class="d-block font-weight-bold name">{{ u?.user?.firstname }} {{ u?.user?.lastname }}</span>
					<span class="date text-black-50">{{ u.created_at | date: "medium" }}</span>
				</div>
			</div>
			<div class="mt-2">
				<div class="ml-4 mb-3" *ngIf="!u.editable">
					<p class="comment-text m-0 p-0">{{ u.body }}</p>
					<div class="form-group" *ngIf="u.assigned_attachments && u.assigned_attachments.length > 0">
						<ul class="list-group" *ngFor="let u of u.assigned_attachments">
							<li class="list-group-item d-flex justify-content-between align-items-center">
								<div class="row">
									<div class="col-md-12">
										<a (click)="viewAttachmentComment(u)" class="link-primary" href="javascript:void(0);">
											<i class="fa fa-paperclip mr-4 fa-2x" aria-hidden="true"></i>{{ u.fileurl }}
										</a>
									</div>
								</div>
							</li>
						</ul>
					</div>

					<a [class.disabled]="isImporting" (click)="editCommentItem(i)" class="link-primary" href="javascript:void(0);">Edit</a> -
					<a (click)="deleteCommentItem(i)" class="link-danger" [class.disabled]="isImporting" href="javascript:void(0);">Delete</a>
				</div>
				<div class="ml-4 mb-3" *ngIf="u.editable">
					<textarea class="form-control textarea" name="text" [(ngModel)]="u.body"></textarea>

					<div class="form-group" *ngIf="u.assigned_attachments && u.assigned_attachments.length > 0">
						<ul class="list-group" *ngFor="let u of u.assigned_attachments; let ia = index">
							<li class="list-group-item d-flex justify-content-between align-items-center">
								<div class="row">
									<div class="col-md-12">
										<a (click)="viewAttachmentComment(u)" class="link-primary" href="javascript:void(0);">
											<i class="fa fa-paperclip mr-4 fa-2x" aria-hidden="true"></i>{{ u.fileurl }}
										</a>
									</div>
								</div>
								<div class="row">
									<div class="col-md-12">
										<a [class.disabled]="isImporting" href="javascript:;" class="text-danger" title="Remove" (click)="deleteAttachment(i, ia)">
											<i class="fas fa-times"></i>
										</a>
									</div>
								</div>
							</li>
						</ul>
					</div>

					<span class="badge badge-primary m-1" *ngFor="let file of u.filestoupload; let i = index">
						{{ file.file.name }}
						<a [class.disabled]="isImporting" href="javascript:;" class="text-danger" title="Remove" (click)="u.filestoupload.splice(i, 1)">
							<i class="fas fa-times"></i>
						</a>
					</span>

					<div class="mt-2">
						<button [disabled]="isImporting" class="btn btn-primary btn-sm" (click)="saveCommentItem(i)" type="button">
							<span *ngIf="!isImporting">Save</span>
							<mat-spinner [diameter]="20" *ngIf="isImporting"></mat-spinner>
						</button>
						<button [disabled]="isImporting" class="btn btn-outline-primary btn-sm ml-1" (click)="cancelCommentItem()" type="button">Cancel</button>
						<input type="file" hidden #uploaderitem class="form-control" id="files" multiple (change)="handleFileInputItem($event, i)" />
						<button [disabled]="isImporting" (click)="uploaderitem.click()" class="btn btn-outline-primary btn-sm float-right" type="button">
							<i class="fa fa-paperclip" aria-hidden="true"></i>
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div-->
